"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContent;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Display content of each Tab. The Tabs component can optionally use TabContent.
 * @param {Object} props props
 * @displayName Tab Content
 * @public
 * @returns {React.ReactElement} TabContent
 */
function TabContent(props) {
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    tabIndex: props.tabIndex,
    role: "tabpanel"
  }));
}

/**
 * Property validation
 *
 * @type {Object}
 * @api private
 */
TabContent.propTypes = {
  /** Classes to be applied to tab content */
  className: _propTypes.default.string,
  /** Contents of the tab */
  children: _propTypes.default.node,
  /** Developer indicates tabIndex, default is 0 */
  tabIndex: _propTypes.default.oneOf([-1, 0])
};
TabContent.defaultProps = {
  tabIndex: 0
};